type ExtractItemValue = (item: any) => any;

type ArraySortCallback = (
  item1: any,
  item2: any,
  extractValueForComparison: ExtractItemValue
) => any;

const sortNumbersAscCallback: ArraySortCallback = (item1, item2, extractValueForComparison) => {
  return extractValueForComparison(item1) - extractValueForComparison(item2);
};

const sortDatesAscCallback: ArraySortCallback = (item1, item2, extractValueForComparison) => {
  return sortNumbersAscCallback(item1, item2, extractValueForComparison);
};

export function sortAscByDate(array: any[], valueExtractorForComparison: ExtractItemValue) {
  array.sort((item1, item2) => sortDatesAscCallback(item1, item2, valueExtractorForComparison));
}

export function moveItemInArray(arr: Array<any>, fromIndex: number, toIndex: number) {
  const element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
}
